import type { StoreActions, StoreDetails } from '@api/userAndStoreContext'

/**
 * Extracts StoreDetails from a StoreActions gateway model.
 * The UI works directly with StoreDetails — storeName, physicalAddress, storeId, tags, etc.
 */
export function mapStoreToStoreDetails (store: StoreActions): StoreDetails {
    const details = store.storeDetails || { storeId: store.storeId }
    if (!details.storeName) {
        console.warn(`[storeMapper] Store ${store.storeId} has no storeName.`)
    }
    return details
}

/**
 * Extracts StoreDetails from an array of StoreActions.
 */
export function mapStoresToStoreDetails (stores: StoreActions[]): StoreDetails[] {
    return stores.map(mapStoreToStoreDetails)
}
